unit Unit4;

interface

uses
  SysUtils, Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.StdCtrls, WEBLib.ExtCtrls;

type
  TForm4 = class(TForm)
    WebLabel1: TLabel;
    WebLabel7: TLabel;
    WebGroupBox3: TGroupBox;
    WebLabel45: TLabel;
    WebLabel47: TLabel;
    WebLabel48: TLabel;
    WebLabel50: TLabel;
    WebLabel51: TLabel;
    WebLabel52: TLabel;
    WebLabel53: TLabel;
    WebLabel54: TLabel;
    WebLabel55: TLabel;
    WebLabel56: TLabel;
    WebLabel57: TLabel;
    WebLabel58: TLabel;
    WebLabel59: TLabel;
    WebLabel60: TLabel;
    WebLabel61: TLabel;
    WebLabel64: TLabel;
    WebLabel65: TLabel;
    WebLabel46: TLabel;
    WebLabel72: TLabel;
    WebLabel73: TLabel;
    WebLabel81: TLabel;
    WebLabel82: TLabel;
    WebLabel83: TLabel;
    WebEdit10: TEdit;
    WebEdit16: TEdit;
    WebEdit17: TEdit;
    WebEdit18: TEdit;
    WebEdit31: TEdit;
    WebEdit32: TEdit;
    WebEdit34: TEdit;
    WebEdit6: TEdit;
    WebComboBox7: TComboBox;
    WebEdit1: TEdit;
    WebEdit33: TEdit;
    WebEdit35: TEdit;
  private
    { Private declarations }
  protected
    procedure LoadDFMValues; override;
  public
    { Public declarations }
  end;

var
  Form4: TForm4;

implementation


procedure TForm4.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel1 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebGroupBox3 := TGroupBox.Create(Self);
  WebLabel45 := TLabel.Create(Self);
  WebLabel47 := TLabel.Create(Self);
  WebLabel48 := TLabel.Create(Self);
  WebLabel50 := TLabel.Create(Self);
  WebLabel51 := TLabel.Create(Self);
  WebLabel52 := TLabel.Create(Self);
  WebLabel53 := TLabel.Create(Self);
  WebLabel54 := TLabel.Create(Self);
  WebLabel55 := TLabel.Create(Self);
  WebLabel56 := TLabel.Create(Self);
  WebLabel57 := TLabel.Create(Self);
  WebLabel58 := TLabel.Create(Self);
  WebLabel59 := TLabel.Create(Self);
  WebLabel60 := TLabel.Create(Self);
  WebLabel61 := TLabel.Create(Self);
  WebLabel64 := TLabel.Create(Self);
  WebLabel65 := TLabel.Create(Self);
  WebLabel46 := TLabel.Create(Self);
  WebLabel72 := TLabel.Create(Self);
  WebLabel73 := TLabel.Create(Self);
  WebLabel81 := TLabel.Create(Self);
  WebLabel82 := TLabel.Create(Self);
  WebLabel83 := TLabel.Create(Self);
  WebEdit10 := TEdit.Create(Self);
  WebEdit16 := TEdit.Create(Self);
  WebEdit17 := TEdit.Create(Self);
  WebEdit18 := TEdit.Create(Self);
  WebEdit31 := TEdit.Create(Self);
  WebEdit32 := TEdit.Create(Self);
  WebEdit34 := TEdit.Create(Self);
  WebEdit6 := TEdit.Create(Self);
  WebComboBox7 := TComboBox.Create(Self);
  WebEdit1 := TEdit.Create(Self);
  WebEdit33 := TEdit.Create(Self);
  WebEdit35 := TEdit.Create(Self);

  WebLabel1.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebGroupBox3.BeforeLoadDFMValues;
  WebLabel45.BeforeLoadDFMValues;
  WebLabel47.BeforeLoadDFMValues;
  WebLabel48.BeforeLoadDFMValues;
  WebLabel50.BeforeLoadDFMValues;
  WebLabel51.BeforeLoadDFMValues;
  WebLabel52.BeforeLoadDFMValues;
  WebLabel53.BeforeLoadDFMValues;
  WebLabel54.BeforeLoadDFMValues;
  WebLabel55.BeforeLoadDFMValues;
  WebLabel56.BeforeLoadDFMValues;
  WebLabel57.BeforeLoadDFMValues;
  WebLabel58.BeforeLoadDFMValues;
  WebLabel59.BeforeLoadDFMValues;
  WebLabel60.BeforeLoadDFMValues;
  WebLabel61.BeforeLoadDFMValues;
  WebLabel64.BeforeLoadDFMValues;
  WebLabel65.BeforeLoadDFMValues;
  WebLabel46.BeforeLoadDFMValues;
  WebLabel72.BeforeLoadDFMValues;
  WebLabel73.BeforeLoadDFMValues;
  WebLabel81.BeforeLoadDFMValues;
  WebLabel82.BeforeLoadDFMValues;
  WebLabel83.BeforeLoadDFMValues;
  WebEdit10.BeforeLoadDFMValues;
  WebEdit16.BeforeLoadDFMValues;
  WebEdit17.BeforeLoadDFMValues;
  WebEdit18.BeforeLoadDFMValues;
  WebEdit31.BeforeLoadDFMValues;
  WebEdit32.BeforeLoadDFMValues;
  WebEdit34.BeforeLoadDFMValues;
  WebEdit6.BeforeLoadDFMValues;
  WebComboBox7.BeforeLoadDFMValues;
  WebEdit1.BeforeLoadDFMValues;
  WebEdit33.BeforeLoadDFMValues;
  WebEdit35.BeforeLoadDFMValues;
  try
    Name := 'Form4';
    Left := 0;
    Top := 0;
    Width := 640;
    Height := 429;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 16;
    WebLabel1.Top := 6;
    WebLabel1.Width := 87;
    WebLabel1.Height := 16;
    WebLabel1.Caption := 'Dane bazowe';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clMenuHighlight;
    WebLabel1.Font.Height := 16;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.ParentFont := False;
    WebLabel7.SetParentComponent(Self);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 5;
    WebLabel7.Top := 402;
    WebLabel7.Width := 204;
    WebLabel7.Height := 13;
    WebLabel7.Caption := 'Kalkulator wycena firmy - Biz24.pl (c) 2020';
    WebLabel7.Color := clYellow;
    WebLabel7.Transparent := False;
    WebGroupBox3.SetParentComponent(Self);
    WebGroupBox3.Name := 'WebGroupBox3';
    WebGroupBox3.Left := 5;
    WebGroupBox3.Top := 28;
    WebGroupBox3.Width := 620;
    WebGroupBox3.Height := 361;
    WebGroupBox3.Caption := 'Dane bazowe';
    WebGroupBox3.ChildOrder := 27;
    WebLabel45.SetParentComponent(WebGroupBox3);
    WebLabel45.Name := 'WebLabel45';
    WebLabel45.Left := 18;
    WebLabel45.Top := 24;
    WebLabel45.Width := 68;
    WebLabel45.Height := 13;
    WebLabel45.Caption := 'Rok bazowy';
    WebLabel45.Font.Charset := DEFAULT_CHARSET;
    WebLabel45.Font.Color := clWindowText;
    WebLabel45.Font.Height := -11;
    WebLabel45.Font.Name := 'Tahoma';
    WebLabel45.Font.Style := [fsBold];
    WebLabel45.ParentFont := False;
    WebLabel47.SetParentComponent(WebGroupBox3);
    WebLabel47.Name := 'WebLabel47';
    WebLabel47.Left := 18;
    WebLabel47.Top := 49;
    WebLabel47.Width := 44;
    WebLabel47.Height := 13;
    WebLabel47.Caption := 'Przych'#243'd';
    WebLabel48.SetParentComponent(WebGroupBox3);
    WebLabel48.Name := 'WebLabel48';
    WebLabel48.Left := 250;
    WebLabel48.Top := 49;
    WebLabel48.Width := 18;
    WebLabel48.Height := 13;
    WebLabel48.Caption := 'PLN';
    WebLabel50.SetParentComponent(WebGroupBox3);
    WebLabel50.Name := 'WebLabel50';
    WebLabel50.Left := 18;
    WebLabel50.Top := 74;
    WebLabel50.Width := 85;
    WebLabel50.Height := 13;
    WebLabel50.Caption := 'Koszty materia'#243'w';
    WebLabel51.SetParentComponent(WebGroupBox3);
    WebLabel51.Name := 'WebLabel51';
    WebLabel51.Left := 250;
    WebLabel51.Top := 74;
    WebLabel51.Width := 18;
    WebLabel51.Height := 13;
    WebLabel51.Caption := 'PLN';
    WebLabel52.SetParentComponent(WebGroupBox3);
    WebLabel52.Name := 'WebLabel52';
    WebLabel52.Left := 250;
    WebLabel52.Top := 99;
    WebLabel52.Width := 18;
    WebLabel52.Height := 13;
    WebLabel52.Caption := 'PLN';
    WebLabel53.SetParentComponent(WebGroupBox3);
    WebLabel53.Name := 'WebLabel53';
    WebLabel53.Left := 18;
    WebLabel53.Top := 99;
    WebLabel53.Width := 27;
    WebLabel53.Height := 13;
    WebLabel53.Caption := 'DB-1';
    WebLabel53.Font.Charset := DEFAULT_CHARSET;
    WebLabel53.Font.Color := clWindowText;
    WebLabel53.Font.Height := -11;
    WebLabel53.Font.Name := 'Tahoma';
    WebLabel53.Font.Style := [fsBold];
    WebLabel53.ParentFont := False;
    WebLabel54.SetParentComponent(WebGroupBox3);
    WebLabel54.Name := 'WebLabel54';
    WebLabel54.Left := 250;
    WebLabel54.Top := 124;
    WebLabel54.Width := 18;
    WebLabel54.Height := 13;
    WebLabel54.Caption := 'PLN';
    WebLabel55.SetParentComponent(WebGroupBox3);
    WebLabel55.Name := 'WebLabel55';
    WebLabel55.Left := 18;
    WebLabel55.Top := 124;
    WebLabel55.Width := 78;
    WebLabel55.Height := 13;
    WebLabel55.Caption := 'Koszty osobowe';
    WebLabel56.SetParentComponent(WebGroupBox3);
    WebLabel56.Name := 'WebLabel56';
    WebLabel56.Left := 250;
    WebLabel56.Top := 149;
    WebLabel56.Width := 18;
    WebLabel56.Height := 13;
    WebLabel56.Caption := 'PLN';
    WebLabel57.SetParentComponent(WebGroupBox3);
    WebLabel57.Name := 'WebLabel57';
    WebLabel57.Left := 18;
    WebLabel57.Top := 149;
    WebLabel57.Width := 27;
    WebLabel57.Height := 13;
    WebLabel57.Caption := 'DB-2';
    WebLabel57.Font.Charset := DEFAULT_CHARSET;
    WebLabel57.Font.Color := clWindowText;
    WebLabel57.Font.Height := -11;
    WebLabel57.Font.Name := 'Tahoma';
    WebLabel57.Font.Style := [fsBold];
    WebLabel57.ParentFont := False;
    WebLabel58.SetParentComponent(WebGroupBox3);
    WebLabel58.Name := 'WebLabel58';
    WebLabel58.Left := 250;
    WebLabel58.Top := 174;
    WebLabel58.Width := 18;
    WebLabel58.Height := 13;
    WebLabel58.Caption := 'PLN';
    WebLabel59.SetParentComponent(WebGroupBox3);
    WebLabel59.Name := 'WebLabel59';
    WebLabel59.Left := 18;
    WebLabel59.Top := 174;
    WebLabel59.Width := 84;
    WebLabel59.Height := 13;
    WebLabel59.Caption := 'Koszty sprzedazy';
    WebLabel60.SetParentComponent(WebGroupBox3);
    WebLabel60.Name := 'WebLabel60';
    WebLabel60.Left := 18;
    WebLabel60.Top := 199;
    WebLabel60.Width := 67;
    WebLabel60.Height := 13;
    WebLabel60.Caption := 'Koszty og'#243'lne';
    WebLabel61.SetParentComponent(WebGroupBox3);
    WebLabel61.Name := 'WebLabel61';
    WebLabel61.Left := 250;
    WebLabel61.Top := 199;
    WebLabel61.Width := 18;
    WebLabel61.Height := 13;
    WebLabel61.Caption := 'PLN';
    WebLabel64.SetParentComponent(WebGroupBox3);
    WebLabel64.Name := 'WebLabel64';
    WebLabel64.Left := 18;
    WebLabel64.Top := 249;
    WebLabel64.Width := 55;
    WebLabel64.Height := 13;
    WebLabel64.Caption := 'Cash Flow';
    WebLabel64.Font.Charset := DEFAULT_CHARSET;
    WebLabel64.Font.Color := clWindowText;
    WebLabel64.Font.Height := -11;
    WebLabel64.Font.Name := 'Tahoma';
    WebLabel64.Font.Style := [fsBold];
    WebLabel64.ParentFont := False;
    WebLabel65.SetParentComponent(WebGroupBox3);
    WebLabel65.Name := 'WebLabel65';
    WebLabel65.Left := 250;
    WebLabel65.Top := 249;
    WebLabel65.Width := 18;
    WebLabel65.Height := 13;
    WebLabel65.Caption := 'PLN';
    WebLabel46.SetParentComponent(WebGroupBox3);
    WebLabel46.Name := 'WebLabel46';
    WebLabel46.Left := 17;
    WebLabel46.Top := 224;
    WebLabel46.Width := 82;
    WebLabel46.Height := 13;
    WebLabel46.Caption := 'Koszty pozosta'#322'e';
    WebLabel72.SetParentComponent(WebGroupBox3);
    WebLabel72.Name := 'WebLabel72';
    WebLabel72.Left := 249;
    WebLabel72.Top := 224;
    WebLabel72.Width := 18;
    WebLabel72.Height := 13;
    WebLabel72.Caption := 'PLN';
    WebLabel73.SetParentComponent(WebGroupBox3);
    WebLabel73.Name := 'WebLabel73';
    WebLabel73.Left := 17;
    WebLabel73.Top := 274;
    WebLabel73.Width := 60;
    WebLabel73.Height := 13;
    WebLabel73.Caption := 'Amortyzacja';
    WebLabel81.SetParentComponent(WebGroupBox3);
    WebLabel81.Name := 'WebLabel81';
    WebLabel81.Left := 249;
    WebLabel81.Top := 274;
    WebLabel81.Width := 18;
    WebLabel81.Height := 13;
    WebLabel81.Caption := 'PLN';
    WebLabel82.SetParentComponent(WebGroupBox3);
    WebLabel82.Name := 'WebLabel82';
    WebLabel82.Left := 17;
    WebLabel82.Top := 297;
    WebLabel82.Width := 35;
    WebLabel82.Height := 13;
    WebLabel82.Caption := 'Wynik';
    WebLabel82.Font.Charset := DEFAULT_CHARSET;
    WebLabel82.Font.Color := clWindowText;
    WebLabel82.Font.Height := -11;
    WebLabel82.Font.Name := 'Tahoma';
    WebLabel82.Font.Style := [fsBold];
    WebLabel82.ParentFont := False;
    WebLabel83.SetParentComponent(WebGroupBox3);
    WebLabel83.Name := 'WebLabel83';
    WebLabel83.Left := 249;
    WebLabel83.Top := 297;
    WebLabel83.Width := 18;
    WebLabel83.Height := 13;
    WebLabel83.Caption := 'PLN';
    WebEdit10.SetParentComponent(WebGroupBox3);
    WebEdit10.Name := 'WebEdit10';
    WebEdit10.Left := 176;
    WebEdit10.Top := 71;
    WebEdit10.Width := 68;
    WebEdit10.Height := 19;
    WebEdit10.ChildOrder := 1;
    WebEdit10.Color := clInfoBk;
    WebEdit10.Text := '1200000';
    WebEdit16.SetParentComponent(WebGroupBox3);
    WebEdit16.Name := 'WebEdit16';
    WebEdit16.Left := 176;
    WebEdit16.Top := 96;
    WebEdit16.Width := 68;
    WebEdit16.Height := 19;
    WebEdit16.ChildOrder := 2;
    WebEdit16.Color := 12903679;
    WebEdit16.Enabled := False;
    WebEdit16.Text := '3800000';
    WebEdit17.SetParentComponent(WebGroupBox3);
    WebEdit17.Name := 'WebEdit17';
    WebEdit17.Left := 176;
    WebEdit17.Top := 121;
    WebEdit17.Width := 68;
    WebEdit17.Height := 19;
    WebEdit17.ChildOrder := 3;
    WebEdit17.Color := clInfoBk;
    WebEdit17.Text := '1500000';
    WebEdit18.SetParentComponent(WebGroupBox3);
    WebEdit18.Name := 'WebEdit18';
    WebEdit18.Left := 176;
    WebEdit18.Top := 146;
    WebEdit18.Width := 68;
    WebEdit18.Height := 19;
    WebEdit18.ChildOrder := 4;
    WebEdit18.Color := 12903679;
    WebEdit18.Enabled := False;
    WebEdit18.Text := '2300000';
    WebEdit31.SetParentComponent(WebGroupBox3);
    WebEdit31.Name := 'WebEdit31';
    WebEdit31.Left := 176;
    WebEdit31.Top := 171;
    WebEdit31.Width := 68;
    WebEdit31.Height := 19;
    WebEdit31.ChildOrder := 5;
    WebEdit31.Color := clInfoBk;
    WebEdit31.Text := '300';
    WebEdit32.SetParentComponent(WebGroupBox3);
    WebEdit32.Name := 'WebEdit32';
    WebEdit32.Left := 176;
    WebEdit32.Top := 196;
    WebEdit32.Width := 68;
    WebEdit32.Height := 19;
    WebEdit32.ChildOrder := 6;
    WebEdit32.Color := clInfoBk;
    WebEdit32.Text := '1400000';
    WebEdit34.SetParentComponent(WebGroupBox3);
    WebEdit34.Name := 'WebEdit34';
    WebEdit34.Left := 176;
    WebEdit34.Top := 246;
    WebEdit34.Width := 68;
    WebEdit34.Height := 19;
    WebEdit34.ChildOrder := 7;
    WebEdit34.Color := 12903679;
    WebEdit34.Enabled := False;
    WebEdit34.Text := '400000';
    WebEdit6.SetParentComponent(WebGroupBox3);
    WebEdit6.Name := 'WebEdit6';
    WebEdit6.Left := 176;
    WebEdit6.Top := 46;
    WebEdit6.Width := 68;
    WebEdit6.Height := 19;
    WebEdit6.ChildOrder := 8;
    WebEdit6.Color := clInfoBk;
    WebEdit6.Text := '5000000';
    WebComboBox7.SetParentComponent(WebGroupBox3);
    WebComboBox7.Name := 'WebComboBox7';
    WebComboBox7.Left := 176;
    WebComboBox7.Top := 21;
    WebComboBox7.Width := 68;
    WebComboBox7.Height := 22;
    WebComboBox7.Color := clInfoBk;
    WebComboBox7.Text := '2020';
    WebComboBox7.ItemIndex := 5;
    WebComboBox7.Items.BeginUpdate;
    try
      WebComboBox7.Items.Clear;
      WebComboBox7.Items.Add('2015');
      WebComboBox7.Items.Add('2016');
      WebComboBox7.Items.Add('2017');
      WebComboBox7.Items.Add('2018');
      WebComboBox7.Items.Add('2019');
      WebComboBox7.Items.Add('2020');
      WebComboBox7.Items.Add('2021');
      WebComboBox7.Items.Add('2022');
      WebComboBox7.Items.Add('2023');
      WebComboBox7.Items.Add('2024');
      WebComboBox7.Items.Add('2025'#11);
      WebComboBox7.Items.Add('');
    finally
      WebComboBox7.Items.EndUpdate;
    end;
    WebEdit1.SetParentComponent(WebGroupBox3);
    WebEdit1.Name := 'WebEdit1';
    WebEdit1.Left := 175;
    WebEdit1.Top := 221;
    WebEdit1.Width := 68;
    WebEdit1.Height := 19;
    WebEdit1.ChildOrder := 7;
    WebEdit1.Color := clInfoBk;
    WebEdit1.Text := '200000';
    WebEdit33.SetParentComponent(WebGroupBox3);
    WebEdit33.Name := 'WebEdit33';
    WebEdit33.Left := 175;
    WebEdit33.Top := 271;
    WebEdit33.Width := 68;
    WebEdit33.Height := 19;
    WebEdit33.ChildOrder := 7;
    WebEdit33.Color := clInfoBk;
    WebEdit33.Text := '100000';
    WebEdit35.SetParentComponent(WebGroupBox3);
    WebEdit35.Name := 'WebEdit35';
    WebEdit35.Left := 175;
    WebEdit35.Top := 294;
    WebEdit35.Width := 68;
    WebEdit35.Height := 19;
    WebEdit35.ChildOrder := 7;
    WebEdit35.Color := 12903679;
    WebEdit35.Enabled := False;
    WebEdit35.Text := '300000';
  finally
    WebLabel1.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebGroupBox3.AfterLoadDFMValues;
    WebLabel45.AfterLoadDFMValues;
    WebLabel47.AfterLoadDFMValues;
    WebLabel48.AfterLoadDFMValues;
    WebLabel50.AfterLoadDFMValues;
    WebLabel51.AfterLoadDFMValues;
    WebLabel52.AfterLoadDFMValues;
    WebLabel53.AfterLoadDFMValues;
    WebLabel54.AfterLoadDFMValues;
    WebLabel55.AfterLoadDFMValues;
    WebLabel56.AfterLoadDFMValues;
    WebLabel57.AfterLoadDFMValues;
    WebLabel58.AfterLoadDFMValues;
    WebLabel59.AfterLoadDFMValues;
    WebLabel60.AfterLoadDFMValues;
    WebLabel61.AfterLoadDFMValues;
    WebLabel64.AfterLoadDFMValues;
    WebLabel65.AfterLoadDFMValues;
    WebLabel46.AfterLoadDFMValues;
    WebLabel72.AfterLoadDFMValues;
    WebLabel73.AfterLoadDFMValues;
    WebLabel81.AfterLoadDFMValues;
    WebLabel82.AfterLoadDFMValues;
    WebLabel83.AfterLoadDFMValues;
    WebEdit10.AfterLoadDFMValues;
    WebEdit16.AfterLoadDFMValues;
    WebEdit17.AfterLoadDFMValues;
    WebEdit18.AfterLoadDFMValues;
    WebEdit31.AfterLoadDFMValues;
    WebEdit32.AfterLoadDFMValues;
    WebEdit34.AfterLoadDFMValues;
    WebEdit6.AfterLoadDFMValues;
    WebComboBox7.AfterLoadDFMValues;
    WebEdit1.AfterLoadDFMValues;
    WebEdit33.AfterLoadDFMValues;
    WebEdit35.AfterLoadDFMValues;
  end;
end;

end.